
import EmailViewer from "@/components/email/EmailViewer";
import ResponseActions from "./ResponseActions";
import ResponseContent from "./ResponseContent";
import { type Email } from "@/types/email";
import { useState } from "react";

interface GeneratedResponseViewProps {
  email: Email;
  response: string;
  isGenerating: boolean;
  emailSent: boolean;
  onResponseChange: (response: string) => void;
  onRegenerate: () => void;
  onSend: (options: { subject: string; cc?: string; bcc?: string; attachments?: File[] }) => void;
}

const GeneratedResponseView = ({
  email,
  response,
  isGenerating,
  emailSent,
  onResponseChange,
  onRegenerate,
  onSend,
}: GeneratedResponseViewProps) => {
  const [attachments, setAttachments] = useState<File[]>([]);

  const handleAttachmentAdd = (file: File) => {
    setAttachments(prev => [...prev, file]);
  };

  const handleSend = (options: { subject: string; cc?: string; bcc?: string }) => {
    onSend({
      ...options,
      attachments: attachments.length > 0 ? attachments : undefined
    });
  };

  return (
    <div className="space-y-4">
      <EmailViewer email={email} hideSubject={true} />
      
      <div className="space-y-4 rounded-lg bg-blue-50 p-4">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-blue-900">AI Response</h3>
          <ResponseActions
            onRegenerate={onRegenerate}
            onSend={handleSend}
            onAttachmentAdd={handleAttachmentAdd}
            isGenerating={isGenerating}
            emailSent={emailSent}
            attachments={attachments}
          />
        </div>
        
        <ResponseContent
          content={response}
          onChange={onResponseChange}
        />
      </div>
    </div>
  );
};

export default GeneratedResponseView;
